import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { setUserPermissions, setPortalSettingInfo } from "../reducers/userPermissions";
import type { UserPermissionsData, PortalSettingInfoData } from "@ServerTypes/portal/portal.schema";
import type {
  GetUserPermissionsRequest,
  GetUserPermissionsResponse,
} from "@ServerTypes/permissions/permissions.schema";
import type {
  GetNotificationPreferenceRequest,
  GetNotificationPreferenceResponse,
  SaveUserSettingsRequest,
  SaveUserSettingsResponse,
  GetUserSettingsRequest,
  GetUserSettingsResponse,
  DeleteUserSettingsRequest,
  DeleteUserSettingsResponse,
} from "@ServerTypes/userSettings/userSettings.schema";
import type { GetPortalSettingsObjectResponse } from "@ServerTypes/portal/portal.schema";

export function getUserPermissions(data: GetUserPermissionsRequest) {
  return (dispatch: AppDispatch) => {
    axiosWrapper
      .post<GetUserPermissionsResponse>(`${getBackendUrl()}/permissions/getUserPermissions`, data)
      .then((response) => {
        if (response && response.data.status) {
          dispatch(setUserPermissions(response.data.data as UserPermissionsData));
        }
      });
  };
}
export const getNotificationPreference = async (data: GetNotificationPreferenceRequest) => {
  const response = await axiosWrapper.post<GetNotificationPreferenceResponse>(
    `${getBackendUrl()}/userSettings/getNotificationPreference`,
    data,
  );
  return response;
};

export function getPortalSetting() {
  return async (dispatch: AppDispatch) => {
    const responseData = await axiosWrapper.get<GetPortalSettingsObjectResponse>(
      `${getBackendUrl()}/portal/getPortalSettingsObject`,
    );
    if (responseData.status) {
      dispatch(setPortalSettingInfo(responseData.data.data as PortalSettingInfoData));
    }
  };
}
export const saveUserSettings = async (data: SaveUserSettingsRequest) => {
  const response = axiosWrapper.post<SaveUserSettingsResponse>(
    `${getBackendUrl()}/userSettings/saveUserSettings`,
    data,
  );
  return response;
};
export const getUserSettings = async (data: GetUserSettingsRequest) => {
  const response = axiosWrapper.post<GetUserSettingsResponse>(`${getBackendUrl()}/userSettings/getUserSettings`, data);
  return response;
};
export const deleteUserSettings = async (data: DeleteUserSettingsRequest) => {
  const response = axiosWrapper.post<DeleteUserSettingsResponse>(
    `${getBackendUrl()}/userSettings/deleteUserSettings`,
    data,
  );
  return response;
};
